<ng-template #template>
  <ng-container *ngIf="isDisplayed">
    <div class="l-mybooking__option-item">
      <asw-next-action-item
        (clickNextAction)="onClick()"
        [canBeClicked]="canBeClicked"
        [title]="'message.registMailAddressInformation' | staticMsg"
        [titleAria]="'reader.registration' | staticMsg"
        [textContent]="'message.notificationbyMail' | staticMsg"
        itemId="register-email"
      >
      </asw-next-action-item>
    </div>
  </ng-container>
</ng-template>
